/**
 * @description UI Store Module
 * @author Fahid Mohammad
 */

const VueCookie = require('vue-cookie') // using require to avoid SSR rejection

export default {
    namespaced: true,
    state: {
        isDashboard:false,
        isHospital:false,
        isDoctor:false,
        isReports:false,
        isRole:false,
        isAccounts:false,
        isSettings:false,
        isReviews:false,
        isSubmenu:false,
        isChangepwd:false,
        isPackages:false,
        rateAndReviewFilter: {
            page: 1,
            limit: 15,
            stid: "",
            from: "",
            to: "",
            dept_id: "",
            unread: false,
            read: false,
            apnt_id:'',
            rtg:null
        }
    },
    mutations:{
        updateIs: (state, {which} ) => {
            //  Reset Is's
            switch(which){
                case 'dashboard': state.isDashboard = true; break;
                case 'hospital': state.isHospital = true; break;
                case 'doctor': state.isDoctor = true; break;
                case 'reports': state.isDoctor = true; break;
                case 'rolemanager': state.isRoleManager = true; break;
                case 'accounts': state.isAccounts = true; break;
                case 'settings': state.isSettings = true; break;
                case 'reviews': state.isReviews = true; break;
                case 'submenu': state.isSubmenu = true; break;
                case 'changepassword':state.isChangepwd=true;break;
                case 'Packages':state.isPackages=true;break;
            }

        },
        setRateAndReviewFilter: (state,payload) => {
           state.rateAndReviewFilter = { ...state.rateAndReviewFilter, ...payload }
        },
        resetIs: (state) => {
            state.isDashboard = false;
            state.isHospital = false;
            state.isDoctor = false;
            state.isReports = false;
            state.isRoleManager = false;
            state.isAccounts = false;
            state.isSettings = false;
            state.isReviews = false;
            state.isSubmenu = false;
            state.isChangepwd = false;
            state.isisPackages = false
        },
    },
    actions:{
        UPDATE_IS({ commit }, which) {
            commit('updateIs', { which })
        },
        RESET_IS({ commit }) {
            commit('resetIs')
        },
    },
    getters:{
        isDashboard: state => { return state.isDashboard },
        isHospital: state => { return state.isHospital },
        isDoctor: state => { return state.isDoctor },
        isReports: state => { return state.isReports },
        isRole: state => { return state.isRoleManager },
        isAccounts: state => { return state.isAccounts },
        isSettings: state => { return state.isSettings },
        isReviews: state => { return state.isReviews },
        isSubmenu: state => { return state.isSubmenu },
        isChangepwd:state => { return state.isChangepwd },
        isPackages:state => {return state.isPackages},
        rateAndReviewFilter: state => state.rateAndReviewFilter,
    }
}
    


// WEBPACK FOOTER //
// ./src/store/modules/ui.js